export const addCommaNumber = (value: number | string) => {
    if (value === 0) {
        return 0
    }
    return value && value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
